import { Component, OnInit } from '@angular/core';
import { Countries } from "../../enums";
import { TalentHappyPathDataService } from "../shared/service/talent-happy-path-data-service";
import { getJobBoardUrl } from "../shared/util/talent-happy-path-util";
import { Router } from "@angular/router";

@Component({
  selector: 'app-job-posting-closed',
  standalone: false,
  templateUrl: './job-posting-closed.component.html',
  styleUrl: './job-posting-closed.component.scss'
})
export class JobPostingClosedComponent implements OnInit {
  postingInfo: PostingInfo;
  jobBoardUrl: string;

  constructor(private talentHappyPathDataService: TalentHappyPathDataService, private router: Router) {
  }

  ngOnInit() {
    this.postingInfo = this.talentHappyPathDataService.postingInfo;
    const countryId = this.postingInfo ? this.postingInfo.countryId : 0;
    this.jobBoardUrl = getJobBoardUrl(countryId)
  }

  showBodyText() {
    return this.postingInfo && this.postingInfo.countryId != Countries.JP;
  }

  navigateToGeneralApplication() {
    // TODO add this to a workflow service when we have a generic one
    this.router.navigateByUrl('/quick-apply/account', { skipLocationChange: false });
  }

  navigateToJobBoard() {
    window.location.href = this.jobBoardUrl;
  }

  isLoggedInUser() {
    return this.talentHappyPathDataService.talent?.personId;
  }
}
